import { FormFeedback, Input, Label } from "reactstrap";
import { CompletedTickIcon, PencilIcon } from '../../../../components/Common/SvgIcons';

import { useEffect, useState } from "react";
import showpasswordlogo from "../../../../../src/assets/images/lystfacelogos/showpassword.svg"
import hidepasswordlogo from "../../../../../src/assets/images/lystfacelogos/hidepassword.svg"
import DmPhoneNumberInput from "../../../../components/Common/Inputs/phone";

const CommonInputField = ({ inputLabel, inputValue, inputKey, handleEditClick, applicationStatus, handleVerify, validationType, verified, labelText, from, isLoading }) => {
    const handleSetPassword = (e) => {
        setIsShowPassword(!isShowPassword)
    }
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [dailcode, setDialcode] = useState(null)

    useEffect(() => {
        if (dailcode) {
            validationType.setFieldValue("dialCode", dailcode)

        }
    }, [dailcode])

    const handlePhoneChange = (phoneDetails, name, e) => {
        validationType.setFieldValue("cmpPhoneCode", phoneDetails.cCode)
        validationType.setFieldValue("phone", phoneDetails.phNum)
        setDialcode(phoneDetails.dialCode)

    }

    return (
        <div className={`form-settings-input-container`}>


            {
                inputKey === "currentPwd" ?
                    <>
                        {
                            labelText &&
                            <span>{labelText}</span>
                        }

                        <div className={`form-password-container`}>

                            <Label className={`form-input-title ${inputLabel.length === 0 ? "invisible" : ""}`}>
                                {inputLabel}<span className="text-danger"> *</span>
                            </Label>

                            <Input
                                name={inputKey}
                                className={`form-input password-input `}
                                formNoValidate
                                type={isShowPassword ? `text` : "password"}
                                onChange={validationType.handleChange}
                                onBlur={validationType.handleBlur}
                                value={inputValue?.trimStart() || ""}
                                autoComplete="new-password"

                            />
                            <span onClick={handleSetPassword} className="password-icon">
                                <img src={!isShowPassword ? hidepasswordlogo : showpasswordlogo} />
                            </span>

                        </div>
                    </>

                    :
                    (inputKey === "phone" && applicationStatus === "edit") ?
                        <>
                            <Label className="form-input-title">
                                Phone number<span className="text-danger"> *</span>
                            </Label>
                            <DmPhoneNumberInput
                                error={(validationType.touched.phone || validationType.touched.cmpPhoneCode) && (validationType.errors.phone || validationType.errors.cmpPhoneCode) ? validationType.errors.phone : ''}
                                onInputChange={handlePhoneChange}
                                onBlur={validationType.handleBlur}
                                className={`dm-input form-input password-input ${(validationType.touched.phone || validationType.touched.cmpPhoneCode) && (validationType.errors.phone || validationType.errors.cmpPhoneCode)
                                    ? `border-danger`
                                    : ``
                                    }`}
                                name="phone"
                                countryCode={validationType.values.cmpPhoneCode || ""}
                                phoneNum={validationType.values.phone || ""}
                            />

                        </> :
                        <div id={inputKey}>
                            <Label className={`${applicationStatus === "manage" ? `form-manage-title ${inputKey}` : "form-input-title"}`}>
                                {inputLabel}<span className="text-danger"> *</span>
                            </Label>
                            <div className='input-container'>
                                <div className='left-container'>

                                    <Input
                                        name={inputKey}
                                        className='form-manage-input'
                                        formNoValidate={true}
                                        type="text"
                                        value={inputValue || ''}
                                        onChange={validationType.handleChange}
                                        onBlur={validationType.handleBlur}
                                        readOnly={applicationStatus === "manage" ? true : false}
                                        disabled={applicationStatus === "manage" ? true : false} />

                                    {
                                        applicationStatus === "manage" ?
                                            verified ?
                                                <div className='completed-icon'>{CompletedTickIcon}</div>
                                                :
                                                <div className="verify-container">
                                                    < span className='verify' onClick={() => handleVerify(inputKey, "verify")}>Verify</span>
                                                    {
                                                        isLoading &&
                                                        <div className="spinner-container spinner-border">
                                                        </div>
                                                    }

                                                </div>
                                            :
                                            null

                                    }
                                    {validationType.touched[inputKey] && validationType.errors[inputKey] && applicationStatus === "edit" ? (
                                        <FormFeedback type="invalid" className="d-block">
                                            {validationType.errors[inputKey]}
                                        </FormFeedback>
                                    ) : null}

                                </div>
                                {
                                    applicationStatus === "manage" &&
                                    <div className='edit-icon' onClick={() => handleEditClick(inputKey)}>
                                        {PencilIcon}
                                    </div>
                                }



                            </div>
                        </div>
            }





        </div >
    )
}

export default CommonInputField;